import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormSelect, FormToggle } from '@getro/rombo';
import { Box, Flex } from 'rebass/styled-components';
import { useGetNetworkAdminsQuery } from '../../../services/networkAdmins';

const IntroRequest = ({
  value,
  onChange: onIntroRequestManagerChange,
  onDropDownStateChange,
  showIntroRequest,
  onShowIntroRequestChange,
}) => {
  const { data: networkAdmins } = useGetNetworkAdminsQuery();

  const { options, currentUser } = useMemo(() => {
    if (!networkAdmins) return { options: [], currentUser: null };

    const admins = networkAdmins.map(({ id, firstName, lastName, email }) => ({
      label: `${firstName} ${lastName ?? ''} (${email})`,
      value: id,
    }));

    return {
      options: admins,
      currentUser: admins.find((admin) => admin.value === value),
    };
  }, [networkAdmins, value]);

  return (
    <Flex
      sx={{
        gap: '16px',
        flexDirection: 'column',
      }}
    >
      <FormToggle
        label="Enable intro requests"
        onChange={onShowIntroRequestChange}
        helpText="Let visitors request intros to the contacts in this list."
        field={{
          id: 'show-point-of-contact',
          name: 'show-point-of-contact',
          value: showIntroRequest,
        }}
        form={{
          setFieldValue: (_, checked) => onShowIntroRequestChange(checked),
        }}
        sx={{ mb: '8px' }}
      />
      {showIntroRequest && (
        <Box
          sx={{
            'label span': {
              color: 'text.main',
              fontWeight: '400',
            },
          }}
        >
          <FormSelect
            required
            label="Who should receive intro requests?"
            options={options}
            size="medium"
            anchorToBody
            onMenuOpen={() => onDropDownStateChange('open')}
            onMenuClose={() => onDropDownStateChange('close')}
            field={{
              id: 'pointOfContact',
              name: 'pointOfContact',
              onChange: ({ target: { value: newValue } }) => {
                onIntroRequestManagerChange(newValue);
              },
              value: currentUser || null,
            }}
          />
        </Box>
      )}
    </Flex>
  );
};

IntroRequest.propTypes = {
  value: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onDropDownStateChange: PropTypes.func.isRequired,
  showIntroRequest: PropTypes.bool.isRequired,
  onShowIntroRequestChange: PropTypes.func.isRequired,
};

export default IntroRequest;
